module.exports = __webpack_public_path__ + "img/spacelab.46c2961d.png";